import { combineReducers } from 'redux';
import pa from '../screens/PA/screens/ApprovePersonal/reducers';
import setting from '../screens/Setting/reducers';
import mydata from '../screens/MyData/reducers';
import userReducer from './userReducer';
import myteam from '../screens/MyTeams/reducers';
import hire from '../screens/Hire/reducers';
import preview from '../screens/Preview/reducers';
import cvFieldsReducer from './cvFieldsReducer';
import report from '../screens/Report/reducers';

import messageReducer from './messageReducer';
export default combineReducers({
  hire,
  pa,
  setting,
  mydata,
  userReducer,
  myteam,
  messageReducer,
  preview,
  cvFieldsReducer,
  report,
});



/** WEBPACK FOOTER **
 ** D:/a/1/s/Tube.Frontend/src/containers/App/screens/Foundation/reducers/index.js
 **/